module.exports = __webpack_public_path__ + "assets/1495a3d68b15b8622c53f6688b64809f.js";